import { render, staticRenderFns } from "./seccionEco.vue?vue&type=template&id=1a32438e&scoped=true&"
import script from "./seccionEco.vue?vue&type=script&lang=js&"
export * from "./seccionEco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a32438e",
  null
  
)

export default component.exports